<template lang="pug">
md-table-card.card
  form(novalidate='', @submit.stop.prevent='search')
    md-layout.search(md-align='end')
      md-layout.searchContainer(md-flex='40', md-align='end')
        md-layout
          md-input-container
            label Search
            md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
        md-layout(md-flex='15', v-if='searchText != ""')
          md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
            md-icon.icon(md-iconset="fa fa-trash-alt")
        md-layout(md-flex='10')
          md-button.search-btn.md-icon-button.btn(type='submit', :disabled='loading')
            md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(v-if='loading', :loading='loading', :size='45')
  div(v-if="hasMediaSourcesToDisplay")
    div.titleLine.styleRow
      p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements.sortable(@click = "onSort('status')") Status {{sort.name === 'status' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}} 
      p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements
    div.styleRow.colorHover(v-for='mediaSource in mediaSources', :key='mediaSource._id')
      div.rowElements {{mediaSource.name}}
      div.rowElements {{ mediaSource.status }}
      div.rowElements {{ mediaSource.lastUpdated | moment('from') }} 
      div.rowElements
        md-button.md-icon-button.md-raised.btn(@click='editMediaSource(mediaSource._id)')
          md-icon.icon(md-iconset="fa fa-pencil-alt")

  md-table-pagination(
    v-show='hasMediaSourcesToDisplay',
    :md-size='currentPagination.size',
    :md-total='totalMediaSources',
    :md-page='currentPagination.page',
    md-label='Video Sources',
    md-separator='of',
    :md-page-options='[10, 25, 50, 100]',
    @pagination='onPageChanged'
  )

  div#no-results(v-if='hasNoResults')
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import mediaSourceService from '../../services/mediaSourceService';
import stitchLoader from '../../shared-components/Loader';

export default {
  components: {
    stitchLoader
  },
  data() {
    return {
      mediaSources: [],
      totalMediaSources: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: ''
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationMediaSource") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      if(params.limit === undefined){
        params.limit = 10
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalMediaSources != null && params.offset >= this.totalMediaSources) {
        params.offset = 0
      }
      return params;
    },
    hasMediaSourcesToDisplay() {
      return !this.loading && this.mediaSources.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.mediaSources.length === 0;
    }
  },
  methods: {
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageVideoSources", paginationParams.page);
      this.$session.set("limitPaginationMediaSource", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },
    search() {
      this.loading = true;
      mediaSourceService.getList(this.searchParams)
        .then((response) => {
          this.mediaSources = response.data.mediaSources;
          this.totalMediaSources = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of media sources', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    editMediaSource(mediaSourceId) {
      this.$router.push({
        name: 'EditVideoSource',
        params: {
          id: mediaSourceId
        }
      });
    },
    cleanSearchText() {
      this.searchText = '';
      this.search()
    }
  },
  mounted() {
    this.$session.set("limitPagination", this.currentPagination.size);
    this.$session.set("limitPaginationDomains", this.currentPagination.size);
    this.$session.set("limitPaginationDistributions", this.currentPagination.size);

    if (this.$session.get("iWasInPageVideoSources") === undefined) {
      this.$session.set("iWasInPageVideoSources", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPageVideoSources');
    this.currentPagination.size = this.$session.get("limitPaginationMediaSource");
    this.$session.set("limitPagination", this.currentPagination.size);

    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageChannel", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.search {
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 20px;
  }
}

#search {
  margin-bottom: 30px;

  .search-btn {
    margin-top: 16px;
  }

  .clean-search-label-btn {
    margin-top: 16px;
  }
}

.searchContainer {
  flex: none;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #4ea9dd;
}</style>



// WEBPACK FOOTER //
// src/shared-components/mediaSource/MediaSourceTable.vue